import React, { useState, useEffect } from "react";
import { Button, Modal, message, Select, Input } from "antd";
import Layouts from "../../components/Layouts";
import CamposTable from "./components/CamposTable";
import VerValoresModal from "./components/VerValoresModal";
import EditarCampoModal from "./components/EditarCampoModal";
import CrearCampoModal from "./components/CrearCampoModal";
import { obtenerCamposUser, AllRoles, EliminarCampos, Eliminarvalorescampos } from "../../services/formularioUsuarios";

const FormularioUsuarios = () => {
  const [campos, setCampos] = useState([]);
  const [rolesDisponibles, setRolesDisponibles] = useState([]);
  const [selectedCampo, setSelectedCampo] = useState(null);
  const [valoresCampo, setValoresCampo] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [filtroRol, setFiltroRol] = useState(null);
  const [filtroCampo, setFiltroCampo] = useState("");
  const [filtroTipo, setFiltroTipo] = useState(null);

  useEffect(() => {
    const fetchCampos = async () => {
      try {
        const data = await obtenerCamposUser();
        const camposConRoles = data.map((campo) => ({
          ...campo,
          roles: campo.roles.map((rol) => ({
            ...rol,
            nombre: rol.directus_roles_id?.name || "Sin nombre",
          })),
        }));
        setCampos(camposConRoles);
      } catch (error) {
        console.error("Error al obtener los campos:", error);
      }
    };
    fetchCampos();
  }, []);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const roles = await AllRoles();
        setRolesDisponibles(roles);
      } catch (error) {
        console.error("Error al obtener los roles:", error);
      }
    };
    fetchRoles();
  }, []);

  const handleEliminarCampo = async (campoId) => {
    try {
      const valores = await obtenerCamposUser();
      const valoresFiltrados = valores.filter(
        (valor) => valor.campos_users === campoId
      );
      await Promise.all(
        valoresFiltrados.map((valor) => Eliminarvalorescampos(valor.id))
      );
      await EliminarCampos(campoId);
      const data = await obtenerCamposUser();
      setCampos(data);
      message.success("Campo y valores asociados eliminados correctamente");
    } catch (error) {
      console.error("Error al eliminar el campo:", error);
      message.error("Error al eliminar el campo");
    }
  };

  const handleFiltroRolChange = (value) => {
    setFiltroRol(value);
  };

  const handleFiltroCampoChange = (e) => {
    setFiltroCampo(e.target.value);
  };

  const handleFiltroTipoChange = (value) => {
    setFiltroTipo(value);
  };

  const filtrarCampos = () => {
    return campos.filter((campo) => {
      const cumpleRol = filtroRol
        ? campo.roles.some((rol) => rol.directus_roles_id?.id === filtroRol)
        : true;
      const cumpleCampo = filtroCampo
        ? campo.campo.toLowerCase().includes(filtroCampo.toLowerCase())
        : true;
      const cumpleTipo = filtroTipo ? campo.tipo_campo === filtroTipo : true;
      return cumpleRol && cumpleCampo && cumpleTipo;
    });
  };

  const camposFiltrados = filtrarCampos();

  return (
    <Layouts>
      <h2>Campos de Usuario</h2>
      <div style={{ marginBottom: 16, display: "flex", gap: 16 }}>
        <Select
          placeholder="Filtrar por rol"
          style={{ width: 200 }}
          onChange={handleFiltroRolChange}
          options={rolesDisponibles.map((rol) => ({
            value: rol.id,
            label: rol.name,
          }))}
          allowClear
        />
        <Input
          placeholder="Filtrar por nombre"
          style={{ width: 200 }}
          value={filtroCampo}
          onChange={handleFiltroCampoChange}
        />
        <Select
          placeholder="Filtrar por tipo"
          style={{ width: 200 }}
          onChange={handleFiltroTipoChange}
          options={[
            { value: "texto", label: "Texto" },
            { value: "numero", label: "Número" },
            { value: "select", label: "Select" },
            { value: "fecha", label: "Fecha" },
            { value: "imagen", label: "Imagen" },
          ]}
          allowClear
        />
        <Button type="primary" onClick={() => setIsCreateModalOpen(true)}>
          Crear Nuevo Campo
        </Button>
      </div>

      <CamposTable
        campos={camposFiltrados}
        setSelectedCampo={setSelectedCampo}
        setValoresCampo={setValoresCampo}
        setIsModalOpen={setIsModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
        handleEliminarCampo={handleEliminarCampo}
      />

      <VerValoresModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedCampo={selectedCampo}
      />

      <EditarCampoModal
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
        selectedCampo={selectedCampo}
        rolesDisponibles={rolesDisponibles}
        setCampos={setCampos}
      />

      <CrearCampoModal
        isCreateModalOpen={isCreateModalOpen}
        setIsCreateModalOpen={setIsCreateModalOpen}
        rolesDisponibles={rolesDisponibles}
        setCampos={setCampos}
      />
    </Layouts>
  );
};

export default FormularioUsuarios;
